import React from "react";
import { Droppable } from "react-beautiful-dnd";
import Task from "./Task";

const Column = ({ column, tasks }) => {
  return (
    <div className='column' style={{ height: "calc(100vh - 176px)" }}>
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "43px",
          background: column.color
        }}
      >
        <h3 style={{ fontSize: "16px", fontWeight: "600" }}>{column.title}</h3>
      </div>
      <Droppable droppableId={column.id}>
        {(provided) => {
          return (
            <div
              className='task-list'
              ref={provided.innerRef}
              {...provided.droppableProps}
              style={{ width: "100%" }}
            >
              {tasks.map((task, index) => {
                return <Task key={task.id} task={task} index={index} />;
              })}
              {provided.placeholder}
            </div>
          );
        }}
      </Droppable>
    </div>
  );
};

export default Column;
